import { setTreeBuilderName } from '@/treeBuilder/treeBuilderHeader.legacy';
import { updateTableDefinitionName } from '@/treeBuilder/updateTreeName.api';
import { errorToast } from '@/utilities/toast.utilities';

export const useUpdateTreeName = () => {
  const updateTreeName = async (tableId: string, newName: string) => {
    const trimmedName = newName.trim();
    setTreeBuilderName(trimmedName);
    if (tableId) {
      try {
        await updateTableDefinitionName({ tableDefinitionId: tableId, name: trimmedName });
      } catch (error) {
        errorToast({ httpResponseOrError: error });
      }
    }
  };

  return { updateTreeName };
};
